import { render, staticRenderFns } from "./AuthorizationInfoModal.vue?vue&type=template&id=31adaf0c&scoped=true&"
import script from "./AuthorizationInfoModal.vue?vue&type=script&lang=ts&"
export * from "./AuthorizationInfoModal.vue?vue&type=script&lang=ts&"
import style0 from "./AuthorizationInfoModal.vue?vue&type=style&index=0&id=31adaf0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31adaf0c",
  null
  
)

export default component.exports